import React, { useContext } from 'react';
import { useDispatch } from 'react-redux';
import { makeStyles } from '@material-ui/core/styles';
import Grid from '@material-ui/core/Grid';
import _get from 'lodash/get';
import ButtonBase from '@material-ui/core/ButtonBase';
import { setGuideMeOpened } from 'containers/HomePage/actions';
import PageContext from '../PageContext';

const useStyles = makeStyles(theme => ({
  guideMeBtn: {
    height: 52,
    width: 224,
    backgroundColor: props => `#${props.btnBgColor}`,
    color: props => `#${props.btnTextColor}`,
    borderRadius: 5,
    zIndex: 1,
    ...theme.typography.button,
  },
}));

function GuideMeButton() {
  const dispatch = useDispatch();
  const { clientInfo } = useContext(PageContext);
  const { pageText } = clientInfo;
  const btnTextColor = _get(pageText, 'button.textColor', '13619B');
  const btnBgColor = _get(pageText, 'button.backgroundColor', 'E8F1F5');
  const classes = useStyles({ btnTextColor, btnBgColor });

  const handleClickOpen = () => dispatch(setGuideMeOpened(true));

  return (
    <Grid item xs={12}>
      <ButtonBase className={classes.guideMeBtn} onClick={handleClickOpen}>
        GUIDE ME
      </ButtonBase>
    </Grid>
  );
}

GuideMeButton.propTypes = {};

export default GuideMeButton;
